import React from 'react'
import close from './img/close.png'
import search from './img/search.png'
import MediaQuery from 'react-responsive'
import ENV from '../../env'
import PropTypes from 'prop-types'

class SearchInput extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      value: '',
      redirect: false
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange (event) {
    this.setState({value: event.target.value})
  }

  handleSubmit (event) {
    event.preventDefault()
    const section = this.props.section === 'business' ? 'biznis' : 'privatni'
    window.location.assign(`${ENV.root_path}/${this.props.language}/${section}/search/form/?f=${this.state.value}&lang=${this.props.language}&section=${section}`)
  }

  render () {
    const labels = require(`../../trans/${this.props.language}`)

    return (
      <React.Fragment>
        <MediaQuery query='(min-device-width: 1200px)'>
          <div className={'d-flex w-100 pb-3 pt-3 text-center'}>
            <div className={'offset-2 col-1 text-right'}>
          <span className={'pr-1'}>
            <img alt={'search'} className="icon" src={search} onClick={this.handleSubmit}/>
          </span>
            </div>
            <div className="col-6 ml-2">
              <form onSubmit={this.handleSubmit}>
                <div className="row">
                  <input type="text" id={'search'} className="form-control border-bottom border-dark" value={this.state.value} onChange={this.handleChange} placeholder={labels.searchYettel}/>
                </div>
              </form>
            </div>
            <div className={'col-1 mr-2 text-left'}>
              <img alt={'close'} className="icon" src={close} onClick={this.props.handleSearchClose}/>
            </div>
          </div>
        </MediaQuery>

        <MediaQuery query='(max-device-width: 1199px)'>
          <div className={'col-sm-2 col-2 p-0'}>
            <img alt={'search'} className="icon d-block mx-auto" src={search} onClick={this.handleSubmit}/>
          </div>
          <div className="col-sm-8 col-8 pr-2 pl-2 pt-0 pb-0">
            <form onSubmit={this.handleSubmit}>
              <div className="row">
                <input type="text" id={'search'} className="form-control border-bottom border-dark" value={this.state.value} onChange={this.handleChange} placeholder={labels.searchTelenor}/>
              </div>
            </form>
          </div>

          <div className={'col p-0'}>
            <img alt={'close'} className="icon mx-auto d-block" src={close} onClick={this.props.handleSearchClose}/>
          </div>
        </MediaQuery>
      </React.Fragment>
    )
  }
}

SearchInput.propTypes = {
  language: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired,
}

export default SearchInput
